(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-branding.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-branding.js');
"use strict";

const {
  useMemo
} = React;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  useCompetition,
  useIsCompetitionInCurrentProduct
} = svs.components.marketplaceCompetition.services.hooks;
const {
  SubProductBrand
} = svs.components.lbUtils.brandMapping.enum;

const useBranding = function (drawId) {
  var _competition$details;
  let drawCompetitionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const definition = useDefinition();
  const draw = useCurrentDraw(drawId);
  const brandingList = useMemo(() => definition.getBrandNamesByDraw(draw), [definition, draw]);
  const isTipsSmIncludedInBrandingList = brandingList.includes(SubProductBrand.TIPS_SM);
  let skip = false;
  if (!isTipsSmIncludedInBrandingList) {
    skip = true;
  }
  const competitionId = definition.competitionId;
  const competition = useCompetition(competitionId, skip);
  const isCompetitionInCurrentProduct = useIsCompetitionInCurrentProduct(competition === null || competition === void 0 ? void 0 : (_competition$details = competition.details) === null || _competition$details === void 0 ? void 0 : _competition$details.productId, definition === null || definition === void 0 ? void 0 : definition.drawProductIds);
  const removeCompetitionBranding = isTipsSmIncludedInBrandingList && !isCompetitionInCurrentProduct && !drawCompetitionId || isTipsSmIncludedInBrandingList && drawId && !drawCompetitionId;
  const addCompetitionBrandingForDraw = !isTipsSmIncludedInBrandingList && drawId && drawCompetitionId;
  const filteredBrandingList = useMemo(() => {
    let filteredList = brandingList;
    if (removeCompetitionBranding) {
      filteredList = brandingList.filter(brandingItem => brandingItem !== SubProductBrand.TIPS_SM);
    }
    if (addCompetitionBrandingForDraw) {
      filteredList = brandingList.push(SubProductBrand.TIPS_SM);
    }
    return filteredList;
  }, [brandingList, removeCompetitionBranding, addCompetitionBrandingForDraw]);
  return filteredBrandingList;
};
setGlobal('svs.components.tipsen.hooks.useBranding', useBranding);

 })(window);